// extracted by mini-css-extract-plugin
export var modalFooter = "_qi-0";